AGADash.Common = (function () {

    var getRecord = function (data, recordIndex) {
        return data.Formats.reduce(function (result, fmt, i) {
            result[fmt.Name] = data.Values[recordIndex][i];
            return result;
        }, {});
    };

    var getDetailKey = function (data, index, ignoreFields) {
        // Filtrar as chaves
        var keys = data.Formats.filter(function (item) {
            if (ignoreFields && ignoreFields.indexOf(item.Name) >= 0)
                return false;

            if (item.Name === "FA" || item.Name === "COLOR")
                return false;
            return true;
        });

        // Montar o valor da chave
        if (keys.length === 0) return "";
        return keys.reduce(function (res, item, idx) {
            res += "fld|" +
                    item.DataType + "|" +
                    item.Name + "|" +
                    data.Values[index][idx] + "|";
            return res;
        }, "");
        
    };

    var buildDataset = function (data) {
        var dataset = [];
        for (var i = 0; i < data.Values.length; i++) {
            var record = AGADash.Common.getRecord(data, i);
            dataset.push(record);
        }
        return dataset;
    };

    var getFormatInfo = function (data, columnName) {
        for (var i = 0; i < data.Formats.length; i++) {
            if (data.Formats[i].Name === columnName) {
                return data.Formats[i];
            }
        }
        return { Name: columnName, Title: columnName, Format: "" };
    };

    var setLastContextPanel = function (context, panelId) {
        if (typeof (Storage) !== "undefined") {
            var key = "dashPanelContext" + context;
            window.localStorage.setItem(key, panelId);
        }
    };

    var getLastContextPanel = function (context) {
        if (typeof (Storage) !== "undefined") {
            var key = "dashPanelContext" + context;
            var last = window.localStorage.getItem(key);
            return (last ? last : "");
        }
        return "";
    }

    return {
        getRecord: getRecord,

        getDetailKey: getDetailKey,

        buildDataset: buildDataset,

        getFormatInfo: getFormatInfo,

        setLastContextPanel: setLastContextPanel,

        getLastContextPanel: getLastContextPanel
    };

})();

AGADash.Common.Formatter = (function () {

    var dateFormatter = {
        "YYYY": function (y) { return y; },
        "MM/YYYY": function (y, m) { return m + "/" + y; },
        "MM-YYYY": function (y, m) { return m + "-" + y; },
        "DD/MM": function (y, m, d) { return d + "/" + m; },
        "DD-MM": function (y, m, d) { return d + "-" + m; },
        "MM": function (y, m) { return m; },
        "DD": function (y, m, d) { return d; },
        "DD/MM/YYYY": function (y, m, d) { return d + "/" + m + "/" + y; },
        "DD-MM-YYYY": function (y, m, d) { return d + "-" + m + "-" + y; },
        "YYYY/MM": function (y, m) { return y + "/" + m; },
        "YYYY-MM": function (y, m) { return y + "-" + m; }
    };

    var formatDate = function (format, value) {
        if (!value || value.length < 10)
            return "";

        format = format ? format.toUpperCase() : "DD/MM/YYYY";
        var y = value.substring(0, 4);
        var m = value.substring(5, 7);
        var d = value.substring(8, 10);

        var preDefined = dateFormatter[format];
        if (preDefined)
            return preDefined(y, m, d);

        return format.replace("DD", d).replace("MM", m).replace("YYYY", y);
    };

    var formatNumber = function (value, decimals) {
        var vlr = value.toFixed(decimals);
        var parts = vlr.split(".");
        var intPart = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");

        if (decimals === 0)
            return intPart;

        var fracPart = (parts.length > 1) ? parts[1] : '';
        while (fracPart.length < decimals)
            fracPart = fracPart + "0";
        return intPart + "," + fracPart;
    };

    var getPrecision = function (format) {
        if (!format)
            return 0;

        var i = format.indexOf(".");
        if (i > 0) {
            var p = 0;
            while (i < format.length) {
                if (format[i] === "0" || format[i] === "9")
                    p++;
                i++;
            }
            return p;
        }
        return 0;
    };

    var isPercentFormat = function (format) {
        if (format && format.length > 0)
            return (format[format.length - 1] === "%");
        return false;
    };

    var updateNumberFormatInfo = function (formatInfo) {
        if (typeof formatInfo.precision !== "undefined")
            return;

        // Carregar info
        formatInfo.precision = getPrecision(formatInfo.Format);
        formatInfo.isPercentual = isPercentFormat(formatInfo.Format);
    };

    var formatByInfo = function (formatInfo, value) {

        if (formatInfo.DataType === "S")
            return value;

        if (formatInfo.DataType === "N") {
            updateNumberFormatInfo(formatInfo);
            var s = formatNumber(value, formatInfo.precision);
            if (formatInfo.isPercentual)
                s += "%";
            return s;
        }
        return formatDate(formatInfo.Format, value);
    };

    return {
        getPrecision: getPrecision,
        formatByInfo: formatByInfo,
        formatNumber: formatNumber,
        formatDate: formatDate
    };

})();
